import { useState } from 'react';
import { sendEvent, useEventNotification } from '../../features/visual-analytics/hooks/events';
import { ModalPortal } from '../modal-portal/ModalPortal';

import styles from './MessageBoxes.module.scss';

const MSGConfirmBox = 'ShowConfirmBox';

export interface TpConfirmData {
  title: string;
  description: string;
  cancelButtonLabel?: string;
  warningAlert?: boolean;
}

interface TpConfirmModalData {
  confirmData: TpConfirmData;
  callBackOK: any;
  callBackCancel: any;
}

export function promptConfirmationBox(confirmData: TpConfirmData) {
  return new Promise((resolve, reject) => {
    function callBackOK() {
      resolve(true);
    }

    function callBackCancel() {
      reject();
    }

    const confirmModalData: TpConfirmModalData = {
      confirmData,
      callBackOK,
      callBackCancel,
    };
    sendEvent(MSGConfirmBox, confirmModalData);
  });
}

export function ConfirmBox() {
  const [activeBox, setActiveBox] = useState<TpConfirmModalData | null>(null);
  const [showMore, setShowMore] = useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  useEventNotification(
    MSGConfirmBox,
    (tpe: string, contentInput: TpConfirmModalData) => {
      setActiveBox(contentInput);
    },
    [],
  );

  if (!activeBox) return null;

  return (
    <ModalPortal
      close={() => {
        activeBox.callBackCancel();
        setActiveBox(null);
      }}
    >
      <div className={!activeBox.confirmData.warningAlert ? styles.confirmMessageBox : styles.errorMessageBox}>
        <div className={styles.title}>{activeBox.confirmData.title}</div>
        <div className={showMore ? styles.descriptionExpanded : styles.description}>
          <span dangerouslySetInnerHTML={{ __html: activeBox.confirmData.description }} />
        </div>

        {activeBox.confirmData.description.split('\n').length > 5 &&
          (showMore ? (
            <div className={styles.showMoreButton} onClick={toggleShowMore}>
              Show Less
            </div>
          ) : (
            <div className={styles.showMoreButton} onClick={toggleShowMore}>
              Show more
            </div>
          ))}
        <div className={styles.buttonSection}>
          <button
            onClick={() => {
              activeBox.callBackCancel();
              setActiveBox(null);
            }}
          >
            {activeBox.confirmData.cancelButtonLabel ? activeBox.confirmData.cancelButtonLabel : 'Cancel'}
          </button>
          <button
            onClick={() => {
              activeBox.callBackOK();
              setActiveBox(null);
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </ModalPortal>
  );
}
